"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAreaTree = void 0;
var _province = _interopRequireDefault(require("./province"));
var _city = _interopRequireDefault(require("./city"));
var _area = _interopRequireDefault(require("./area"));
/**
 * @description: 获取省市区层级结构（返回Promise）
 * @param {String} level 返回的层级 province省 city市 area区
 * @return {Array} [{name:'广东省',code:440000,children:[{name:'广州市',code:440100,children:[{name:'天河区',code:440106}]}]}]
 */
const getAreaTree = (level = 'area') => {
  return new Promise((resolve, reject) => {
    if (level === 'province') resolve(_province.default);
    if (['city', 'area'].includes(level)) {
      _province.default.forEach((province, index) => {
        province.children = _city.default[index];
        if (level === 'area') {
          _city.default.forEach((city, cityIndex) => {
            city.forEach((city2, cityIndex2) => {
              city2.children = _area.default[cityIndex][cityIndex2];
            });
          });
        }
      });
    }
    resolve(_province.default);
  });
};
exports.getAreaTree = getAreaTree;